import { getAmplitudeInstance } from '../amplitudeHelpers';

type logSponsoredListExternalClickedParams = {
  button_location?: number;
  button_text?: string;
  external_link_url?: string;
  page_slug?: string;
  page_title?: string;
};

/**
 * The user clicks on an external link in a sponsored list
 * @param params - Attributes to log with the amplitude event
 * @param params.button_location - Rank of button location on page; 1 = top most button
 * @param params.button_text - Identifies the text on the button with the external link
 * @param params.external_link_url - The href or url of the external link that is clicked
 * @param params.page_slug - Page slug of sponsored list where the external link is located
 * @param params.page_title - Identifies the page title of the sponsored list
 */
const logSponsoredListExternalClicked = (
  { button_location, button_text, external_link_url, page_slug, page_title }: logSponsoredListExternalClickedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'sponsored list external clicked',
    {
      'button location': button_location,
      'button text': button_text,
      'external link url': external_link_url,
      'page slug': page_slug,
      'page title': page_title
    },
    callback
  );
};

export default logSponsoredListExternalClicked;
